import { render, staticRenderFns } from "./HuellaCarbono.vue?vue&type=template&id=20886892&scoped=true&"
import script from "./HuellaCarbono.vue?vue&type=script&lang=ts&"
export * from "./HuellaCarbono.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20886892",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('20886892', component.options)
    } else {
      api.reload('20886892', component.options)
    }
    module.hot.accept("./HuellaCarbono.vue?vue&type=template&id=20886892&scoped=true&", function () {
      api.rerender('20886892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MedioAmbiente/HuellaCarbono/HuellaCarbono.vue"
export default component.exports